import Vue from 'vue';
import Router from 'vue-router';

/* root */
import RootLayout from './components/pages/root-layout.vue';

/* site pages */
import SitePagesLayout from './components/pages/sitepages/sitepages-layout.vue';

/* fast login */
import FastLogin from './components/pages/sitepages/fastlogin.vue';

/* casino home */
import CasinoHome from './components/pages/sitepages/casino-home/casino-home.vue';
import CasinoMain from './components/pages/sitepages/casino-home/casino-main.vue';
import CasinoCashStart from './components/pages/sitepages/casino-home/casino-cash-start.vue';

/* slots */
import Slots from './components/pages/sitepages/slots/slots.vue';

/* video games */
import VideoGames from './components/pages/sitepages/video-games/video-games.vue';

/* virtual sports */
import VirtualSports from './components/pages/sitepages/virtual-sports/virtual-sports.vue';
import VirtualSportGame from './components/pages/sitepages/virtual-sports/virtual-sport-game/virtual-sport-game.vue';
import VirtualSportHdRaces from './components/pages/sitepages/virtual-sports/virtual-sport-game/hdraces.vue';



/* sport */
import Sport from './components/pages/sitepages/sport/sport.vue';

/* live casino */
import LiveCasino from './components/pages/sitepages/live-casino/live-casino.vue';

/* covid */
import Covid from './components/pages/sitepages/covid/covid.vue';

/* softgamings */
import SoftGamingsGames from './components/pages/sitepages/softgamings/games.vue';

/* toto */
import Toto from './components/pages/sitepages/toto/toto.vue';

/* games */
import Games from './components/pages/sitepages/games/games.vue';
import GamesList from './components/pages/sitepages/games-list/games-list.vue';
import Game from './components/pages/sitepages/game/game.vue'

/* profile */
import Profile from './components/pages/sitepages/profile/profile.vue';
// import ProfileSettings from './components/pages/sitepages/profile/settings.vue';
// import ProfilePassword from './components/pages/sitepages/profile/password.vue';

/* balance */
// import Balance from './components/pages/sitepages/balance/balance.vue';
// import BalanceOperation from './components/pages/sitepages/balance-operation/balance-operation.vue';

/* activate code */
// import ActivateCode from './components/pages/sitepages/activate-code/activate-code.vue';

/* withdraw by code */
// import WithdrawByCode from './components/pages/sitepages/withdraw-by-code/withdraw-by-code.vue';

/* withdrawal codes */
// import WithdrawalCodes from './components/pages/sitepages/withdrawal-codes/withdrawal-codes.vue';

/* history */
import History from './components/pages/sitepages/history/history.vue';
import HistoryTransactions from './components/pages/sitepages/history/transactions.vue';
import HistoryVirtualSports from './components/pages/sitepages/history/virtual-sports.vue';
import HistorySport from './components/pages/sitepages/history/sport.vue';
import HistoryToto from './components/pages/sitepages/history/toto.vue';
/* messages */
// import Messages from './components/pages/sitepages/messages/messages.vue';

/* login */
import Login from './components/pages/sitepages/login/login.vue';

/* registration */
import Registration from './components/pages/sitepages/registration/registration.vue';

/* password restore */
import PasswordRestore from './components/pages/sitepages/password-restore/password-restore.vue';

/* temporary password reset */
import TemporaryPasswordReset from './components/pages/sitepages/temporary-password-reset/temporary-password-reset.vue';

/* rules */
import Rules from './components/pages/sitepages/rules/rules.vue';
import RulesInner from './components/pages/sitepages/rules/rules-inner.vue';
import BonusRules from './components/pages/sitepages/bonus-rules/bonus-rules.vue';

/* promotions */
import Promotions from './components/pages/sitepages/promotions/promotions.vue';
// import PromotionsGetCash from "./components/pages/sitepages/promotions/promotions-get-cash.vue";
// import PromotionsFlyHigh from "./components/pages/sitepages/promotions/promotions-fly-high.vue";
import PromotionsDeposit from "./components/pages/sitepages/promotions/promotions-deposit.vue";
import PromotionsWelcomeBonus from "./components/pages/sitepages/promotions/promotions-welcome-bonus.vue";

/* mobile instruction */
import MobileInstruction from './components/pages/sitepages/mobile-instruction/mobile-instruction.vue';

/* route handlers */
import authRequiredRouteHandler from '../../_common/routehandlers/auth-required.routehandler.js';
import homeRouteHandler from '../../_common/routehandlers/home-route.routehandler.js';
import passwordResetRouteHandler from '../../_common/routehandlers/password-reset.routehandler.js';
var routeHandlers = [authRequiredRouteHandler, homeRouteHandler, passwordResetRouteHandler];

Vue.use(Router);

export function createRouter() {
    let router = new Router({
        // NOTE: our product could be integrated on 3thd site
        mode: 'history',
        linkActiveClass: 'is-active',
        scrollBehavior(to, from, savedPosition) {
            // NOTE: Returning the savedPosition will result in a native- like behavior when navigating with back/ forward buttons
            if (savedPosition) return savedPosition;
            else return { x: 0, y: 0 };
        },

        routes: [
            {
                path: '/',
                name: 'index',
                component: RootLayout,
                children: [
                    {
                        path: '',
                        component: SitePagesLayout,
                        children: [
                            {
                                path: '',
                                name: 'casino-home',
                                component: CasinoHome,
                                props: { backFromGame: true }
                            },
                            {
                                path: '',
                                name: 'casino-cash-start',
                                component: CasinoCashStart,
                                props: { backFromGame: true }
                            },
                            {
                                path: '',
                                name: 'casino-main',
                                component: CasinoMain,
                                props: { backFromGame: true }
                            },
                            {
                                path: 'casino',
                                name: 'slots',
                                component: Slots,
                                props: { backFromGame: true }
                            },
                            {
                                path: 'live-games',
                                name: 'video-games',
                                component: VideoGames,
                                props: { backFromGame: true }
                            },
                            {
                                path: 'game/:provider/:game',
                                name: 'game',
                                component: Game,
                            },
                            {
                                path: 'live-casino',
                                name: 'live-casino',
                                component: LiveCasino,
                                props: { backFromGame: true }
                            },
                            {
                                path: 'covid',
                                name: 'covid',
                                component: Covid
                            },
                            {
                                path: "softgamings",
                                name: "softgamings",
                                component: SoftGamingsGames,
                                props: { backFromGame: true }
                            },
                            {
                                path: 'virtual-sport',
                                name: 'virtual-sports',
                                component: VirtualSports
                            },
                            {
                                path: 'virtual-sport(/.+)?',
                                name: 'virtual-sport-game',
                                component: VirtualSportGame,
                                children: [
                                    {
                                        path: 'hdraces/:game',
                                        name: 'virtual-sport-hdraces',
                                        component: VirtualSportHdRaces
                                    }
                                ]
                            },
                            {
                                path: 'sport/home',
                                name: 'sport-home',
                                component: Sport,
                                props: { showBanner: true, showLogin: true }
                            },
                            {
                                path: 'sport/prematch(/[^$]+)?',
                                name: 'sport-prematch',
                                component: Sport,
                                props: { showBanner: false, showLogin: true }
                            },
                            {
                                path: 'sport/live(/[^$]+)?',
                                name: 'sport-live',
                                component: Sport,
                                props: { showBanner: false, showLogin: true }
                            },
                            {
                                path: 'sport/favorites(/[^$]+)?',
                                name: 'sport-favorites',
                                component: Sport,
                                props: { showBanner: false, showLogin: true }
                            },
                            {
                                path: 'sport/results(/[^$]+)?',
                                name: 'sport-results',
                                component: Sport,
                                props: { showBanner: false, showLogin: false }
                            },
                            {
                                path: 'sport/search(/[^$]+)?',
                                name: 'sport-search',
                                component: Sport,
                                props: { showBanner: false, showLogin: false }
                            },
                            {
                                path: 'sport/lotto(/[^$]+)?',
                                name: 'sport-lottery',
                                component: Sport,
                                props: { showBanner: false, showLogin: false }
                            },
                            {
                                path: 'sport/autoexpress',
                                name: 'sport-autoexpress',
                                component: Sport,
                                props: { showBanner: true, showLogin: false }
                            },
                            {
                                path: 'toto',
                                name: 'toto',
                                component: Toto
                            },
                            {
                                path: 'virtuals',
                                name: 'virtuals',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'virtuals' } ] }
                            },
                            {
                                path: 'shooting',
                                name: 'shooting',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'shooting' } ] }
                            },
                            {
                                path: 'races',
                                name: 'races',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'races' } ] }
                            },
                            {
                                path: 'fast',
                                name: 'fast',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'fast' } ] }
                            },
                            {
                                path: 'poker',
                                name: 'poker',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'poker' } ] }
                            },
                            {
                                path: 'tv-games',
                                name: 'tv-games',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'tv-games' } ] }
                            },
                            {
                                path: 'scratch-games',
                                name: 'scratch-games',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'scratch-games' } ] }
                            },
                            {
                                path: 'table-games',
                                name: 'table-games',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'table-games' } ] }
                            },
                            {
                                path: 'crash',
                                name: 'crash',
                                component: Games,
                                props: { backFromGame: true, filters: [ { category: 'crash' } ] }
                            },
                            {
                                path: 'gl/:gamesList',
                                name: 'games-list',
                                component: GamesList,
                                props: { backFromGame: true }
                            },
                            {
                                path: 'profile',
                                name: 'profile',
                                component: Profile,
                                // redirect: '/profile/settings',
                                /* children: [
                                    {
                                        path: 'settings',
                                        name: 'profile-settings',
                                        component: ProfileSettings
                                    },
                                    {
                                        path: 'password',
                                        name: 'profile-password',
                                        component: ProfilePassword
                                    }
                                ] */
                            },
                            {
                                path: 'balance',
                                name: 'balance',
                                // component: Balance,
                                redirect: '/profile',
                            },
                            /* {
                                path: 'balance/:balanceId/:type(deposit|withdrawal)',
                                name: 'balance-operation',
                                component: BalanceOperation
                            }, */
                            /* {
                                path: 'activate-code',
                                name: 'activate-code',
                                component: ActivateCode
                            }, */
                            /* {
                                path: 'withdraw-by-code',
                                name: 'withdraw-by-code',
                                component: WithdrawByCode
                            }, */
                            /* {
                                path: 'withdrawal-codes',
                                name: 'withdrawal-codes',
                                component: WithdrawalCodes
                            }, */
                            {
                                path: 'history',
                                name: 'history',
                                component: History,
                                children: [
                                    {
                                        path: 'slots',
                                        name: 'history-slots',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'slots' }
                                    },
                                    {
                                        path: 'live-games',
                                        name: 'history-video-games',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'video-games' }
                                    },
                                    {
                                        path: 'live-casino',
                                        name: 'history-live-casino',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'live-casino' }
                                    },
                                    {
                                        path: 'covid',
                                        name: 'history-covid',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'covid' }
                                    },
                                    {
                                        path: 'virtual-sport',
                                        name: 'history-virtual-sports',
                                        component: HistoryVirtualSports
                                    },
                                    {
                                        path: 'sport',
                                        name: 'history-sport',
                                        component: HistorySport
                                    },
                                    {
                                        path: 'toto',
                                        name: 'history-toto',
                                        component: HistoryToto
                                    },
                                    {
                                        path: 'softgamings',
                                        name: 'history-softgamings',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'softgamings' }
                                    },
                                    // ---
                                    {
                                        path: 'virtuals',
                                        name: 'history-virtuals',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'virtuals' }
                                    },
                                    {
                                        path: 'shooting',
                                        name: 'history-shooting',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'shooting' }
                                    },
                                    {
                                        path: 'races',
                                        name: 'history-races',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'races' }
                                    },
                                    {
                                        path: 'fast',
                                        name: 'history-fast',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'fast' }
                                    },
                                    {
                                        path: 'poker',
                                        name: 'history-poker',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'poker'  }
                                    },
                                    {
                                        path: 'tv-games',
                                        name: 'history-tv-games',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'tv-games' }
                                    },
                                    {
                                        path: 'scratch-games',
                                        name: 'history-scratch-games',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'scratch-games' }
                                    },
                                    {
                                        path: 'table-games',
                                        name: 'history-table-games',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'table-games' }
                                    },
                                    {
                                        path: 'crash',
                                        name: 'history-crash',
                                        component: HistoryTransactions,
                                        props: { gameCategory: 'crash' }
                                    },
                                    // ---
                                    {
                                        path: 'deposit-withdraw',
                                        name: 'history-deposit-withdraw',
                                        component: HistoryTransactions,
                                        props: { filterDepositWithdraw: true }
                                    },
                                    {
                                        path: 'bonus',
                                        name: 'history-bonus',
                                        component: HistoryTransactions,
                                        props: { filterBonus: true }
                                    },
                                    {
                                        path: 'all',
                                        name: 'history-all',
                                        component: HistoryTransactions
                                    }
                                ]
                            },
                            /* {
                                path: 'messages',
                                name: 'messages',
                                component: Messages
                            }, */
                            {
                                path: 'login',
                                name: 'login',
                                component: Login,
                                meta: { requiresAuth: false }
                            },
                            {
                                path: 'registration',
                                name: 'registration',
                                component: Registration,
                                meta: { requiresAuth: false }
                            },
                            {
                                path: '/r/:branchCode',
                                component: Registration,
                                props: true,
                                meta: { requiresAuth: false }
                            },
                            {
                                path: 'password-restore',
                                name: 'password-restore',
                                component: PasswordRestore,
                                meta: { requiresAuth: false }
                            },
                            {
                                path: 'temporary-password-reset',
                                name: 'temporary-password-reset',
                                component: TemporaryPasswordReset,
                                meta: { requiresAuth: false }
                            },
                            {
                                path: 'rules',
                                name: 'rules',
                                component: Rules,
                                children:[
                                    {
                                        path: 'bonus',
                                        name: 'bonus-rules',
                                        component: BonusRules
                                    },
                                    {
                                        path: ':rule?',
                                        name: 'rules-inner',
                                        component: RulesInner
                                    }
                                ]
                            },
                            {
                                path: 'promotions',
                                name: 'promotions',
                                component: Promotions,
                            },
                            /* {
                                path: 'promotions/get-cash',
                                name: 'promotions-get-cash',
                                component: PromotionsGetCash
                            },
                            {
                                path: 'promotions/fly-high',
                                name: 'promotions-fly-high',
                                component: PromotionsFlyHigh
                            }, */
                            {
                                path: 'promotions/deposit',
                                name: 'promotions-deposit',
                                component: PromotionsDeposit
                            },
                            {
                                path: 'promotions/welcome-bonus',
                                name: 'promotions-welcome-bonus',
                                component: PromotionsWelcomeBonus
                            },
                            {
                                path: 'mobile-instruction',
                                name: 'mobile-instruction',
                                component: MobileInstruction
                            },
                            {
                                path: '/enter/:loginKey',
                                name: 'enter',
                                component: FastLogin,
                                meta: { requiresAuth: false }
                            }
                        ]
                    }
                ]
            }
        ]
    });

    router.routeHistoryArray = [];
    router.beforeEach(async (to, from, next) => {
        if (from && from.name) Vue.router.routeHistoryArray.splice(0, 0, from);

        Vue.state.route.from.set(from);
        Vue.state.route.to.set(to);

        let handled = false;
        for (let handler of routeHandlers) {
            handled = await handler.handle(to, from, next);
            if (handled) return;
        }
        next();
    });

    return router;
}



// WEBPACK FOOTER //
// ./skins/bulmasite/router.js